import { render, staticRenderFns } from "./Overlay.pug?vue&type=template&id=334cbeca&"
import script from "./Overlay.js?vue&type=script&lang=js&"
export * from "./Overlay.js?vue&type=script&lang=js&"
import style0 from "./Overlay.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports